/* eslint-disable @typescript-eslint/no-explicit-any */
import { isCondition } from './filter.model';

const startOfDay = (value: unknown) => {
  const date = new Date(value as string | number | Date);
  date.setHours(0, 0, 0, 0);
  return date;
};

const nextDay = (value: unknown) => {
  const date = startOfDay(value);
  date.setDate(date.getDate() + 1);
  return date;
};

const convertCondition = (
  [field, operator, value]: [string, string, any],
  dateFields: string[]
): unknown[] | null => {
  const isDate = dateFields.includes(field);
  if (operator === 'anyof') {
    const values: unknown[] = value instanceof Array ? value : [value];
    if (!values.length) {
      return null;
    }
    return values.length === 1
      ? [field, '=', values[0]]
      : values.reduce(
          (acc: unknown[], item, index) => [
            ...acc,
            ...(index ? ['or'] : []),
            [field, '=', item],
          ],
          [] as unknown[]
        );
  }
  if (operator === 'between' && value instanceof Array) {
    return isDate
      ? [
          [field, '>=', startOfDay(value[0])],
          'and',
          [field, '<', nextDay(value[1])],
        ]
      : [[field, '>=', value[0]], 'and', [field, '<=', value[1]]];
  }
  if (isDate && value !== null && value !== undefined) {
    switch (operator) {
      case '<=':
        return [field, '<', nextDay(value)];
      case '>':
        return [field, '>=', nextDay(value)];
      case '=':
        return [
          [field, '>=', startOfDay(value)],
          'and',
          [field, '<', nextDay(value)],
        ];
      default:
        return [field, operator, startOfDay(value)];
    }
  }
  return [field, operator, value];
};

/**
 * The store filter derived from the filter value of the list table, which
 * the list detail page sets to the filter of the companies filter:
 * `anyof` becomes `=` conditions joined with `or`, `between` becomes a `>=`
 * and `<=` pair, and on date columns whole days count (`<=` a day becomes
 * `<` the next day). An empty filter means no filter, so the backend applies
 * the filter of a dynamic list.
 */
export const toGridStoreFilter = (
  filterValue: unknown[] | null | undefined,
  dateFields: string[]
): unknown[] | null => {
  if (!filterValue || !filterValue.length) {
    return null;
  }
  if (isCondition(filterValue)) {
    return convertCondition(filterValue as [string, string, any], dateFields);
  }
  const converted = filterValue
    .map((part) =>
      typeof part === 'string'
        ? part
        : toGridStoreFilter(part as unknown[], dateFields)
    )
    .filter((part) => part !== null);
  return converted.length ? converted : null;
};
